import React, {
    forwardRef,
    useCallback,
    useImperativeHandle,
    useRef,
    useState,
} from 'react';
import styled from 'styled-components';
import ReactionElement from './ReactionElement';

const ReactionDisplay = forwardRef((props, ref) => {
    const [elements, setElements] = useState([]);
    const testRef = useRef([]);

    useImperativeHandle(ref, () => ({
        addReaction(reaction, fromUser) {
            //let emoji = getEmoji(reaction);
            let newArray = [
                ...elements,
                {reaction, fromUser, key: String(Date.now() + Math.random())},
            ];
            setElements(newArray);
            testRef.current = newArray;
        },
    }));

    const onFinished = useCallback(key => {
        let currentElements = testRef.current;
        let filtered = currentElements.filter(element => element.key !== key);
        testRef.current = filtered;
        setElements(filtered);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Container>
            {false && <Count>{props.count} connected</Count>}
            {elements.map(element => {
                return (
                    <ReactionElement
                        key={element.key}
                        id={element.key}
                        fromUser={element.fromUser}
                        reaction={element.reaction}
                        onFinished={onFinished}
                    />
                );
            })}
        </Container>
    );
});

const Container = styled.div`
    position: absolute;
    bottom: 0px;
    right: 0px;
    width: 10px;
    height: 40px;
`;

const Count = styled.div`
    color: black;
    background-color: white;
    position: absolute;
    bottom: -20px;
    padding: 3px 5px;
    border-radius: 3px;
    overflow: hidden;
`;

export default ReactionDisplay;
